export default "__VITE_ASSET__3nNE6vK4__"